import { FormControl, InputLabel, MenuItem } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Select, SelectItem } from '@nextui-org/react'

const CraftTopFilters = ({ setOrder, orderBy, disabled }) => {
    const { t } = useTranslation('common')
    const dropDownOptions = [
        { value: 'craft_id_asc', label: 'Craft ID (Ascending)' },
        { value: 'craft_id_desc', label: 'Craft ID (Descending)' },
        { value: 'date_desc', label: 'Date (Newest)' },
        { value: 'date_asc', label: 'Date (Oldest)' },
        { value: 'template_id_desc', label: 'Template ID (Descending)' },
        { value: 'template_id_asc', label: 'Template ID (Ascending)' },
        { value: 'author_asc', label: 'Collection (Descending)' },
        { value: 'author_desc', label: 'Collection (Ascending)' },
    ]

    const getOption = (order) => {
        const option = Math.max(
            dropDownOptions.map((item) => item.value).indexOf(order),
            0,
        )

        return dropDownOptions[option]
    }

    return (
        <div>
            <FormControl fullWidth size="small" className="flex mx-auto">
                <Select
                    label={t('search.order_by')}
                    value={getOption(orderBy).value}
                    onChange={(e) => setOrder(getOption(e.target.value).value)}
                    variant="faded"
                    size="lg"
                    placeholder="Select"
                    className=" ml-auto max-w-[300px] font-semibold"
                    classNames={{
                        listbox: 'text-black dark:text-white',
                    }}
                >
                    {dropDownOptions.map((option) => (
                        <SelectItem key={option.value} value={option.value}>
                            {option.label}
                        </SelectItem>
                    ))}
                </Select>
            </FormControl>
        </div>
    )
}

export default CraftTopFilters
